import * as React from 'react'
import { SnackbarProvider } from 'notistack'

// RadixDash components
import { useUser } from 'components/RDAuthContext'
import AuthenticatedApp from 'AuthenticatedApp'
import UnauthenticatedApp from 'UnauthenticatedApp'

function App() {
  let authenticated = false

  const user = useUser( )

  user.user == null ? authenticated = false : authenticated = true

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      autoHideDuration={4000}
    >
      {authenticated ? <AuthenticatedApp /> : <UnauthenticatedApp />}
    </SnackbarProvider>
  )
}

export default App